

import { Link } from 'react-router-dom';
import Loader from "react-loader-spinner";
import { useDispatch } from 'react-redux';
import { Card, Table } from 'react-bootstrap';
import { useState, Fragment, useRef } from 'react';
import { getPageFieldList } from '../BaseInfo/store/api/Users';
import { CaretLeftFill, CaretDownFill, GridFill, ListCheck, CardChecklist } from 'react-bootstrap-icons';
const TreeViewItem = (props) => {

    const dispatch = useDispatch();
    const keepChildren = useRef(false);
    const clickOnPermission = useRef(false);
    const [subItems, setSubItems] = useState([]);
    const [fieldList, setFieldList] = useState([]);
    const [panelItems, setPanelItems] = useState([]);
    const [currentNode, setCurrentNode] = useState({});
    const [subMenuDisplay, setSubMenuDisplay] = useState("500px");
    const { title, items, displaySubItems, hasPanel, userID, changedItems } = props;
    const menuClick = () => {
        let d = subMenuDisplay === "0" ? "500px" : "0";
        setSubMenuDisplay(d);
    }
    const nodeClick = (name, text, icon, keepChild, others) => {
        keepChildren.current = keepChild;
        setCurrentNode({ Title: text, Icon: icon });
        if (displaySubItems.fn) {
            setPanelItems("PENDING");
            const onSuccess = (res) => {
                const c = res.filter(r => r.Children.length > 0);
                const others = res.filter(r => r.Children.length === 0);
                if (c.length === 0) {
                    setPanelItems(res);
                }
                else{
                    setPanelItems({Message:"یکی از آیتم های زیرمجموعه را انتخاب کنید"})
                }
                if (!keepChild) {
                    c.forEach(cc => cc.text = cc.PersianName);
                    //To َdd "Others", It Must Be An Intermediate Node (Have Non-Leaf Vertices). === c.length > 0
                    if (others && others.length > 0 && c.length > 0) {
                        others.forEach(o => o.text = o.PersianName);
                        c.push({ Name: name + "_Others", text: "سایر", Others: [...others] });
                    }
                    setSubItems({ Name: name, Nodes: c });
                }
            }
            if (others) {
                setPanelItems(others);
            }
            else {
                if (displaySubItems.canDispatch) {
                    dispatch(displaySubItems.fn(name, userID, onSuccess));
                }
                else {
                    displaySubItems.fn(name, userID, onSuccess);
                }
            }
        }
    }
    const nodeL2Click = (el) => {
        const elArray = document.querySelectorAll(".clickedNodeL2");
        elArray.forEach(el => el.classList.remove("clickedNodeL2"));
        el.classList.add('clickedNodeL2');
    }
    const permissionClick = (type, value, pageID) => {
        let p = changedItems.current.find(c => c.ID === pageID);
        const pnlItem = panelItems.find(i => i.ID === pageID);
        if (!p) {
            p = {};
            p.ID = pageID;
            p.UserID = userID;
            changedItems.current.push(p);
        }
        if (type === "read") {
            pnlItem.IsRead = p.IsRead = value;
        }
        else if (type === "delete") {
            pnlItem.IsDelete = p.IsDelete = value;
        }
        else if (type === "save") {
            pnlItem.IsSave = p.IsSave = value;
        }
        else if (type === "update") {
            pnlItem.IsUpdate = p.IsUpdate = value;
        }
        setPanelItems([...panelItems]);
    }
    const fieldPermissionClick = (type, value, pageID, fieldID) => {
        let p = changedItems.current.find(c => c.ID === pageID);
        if (!p) {
            p = {};
            p.ID = pageID;
            p.UserID = userID;
            changedItems.current.push(p);
        }
        if (!p.FieldList) {
            p.FieldList = [];
        }
        let f = p.FieldList.find(c => c.ID === fieldID);
        if (!f) {
            f = {};
            f.ID = fieldID;
            p.FieldList.push(f);
        }
        if (type === "read") {
            f.IsRead = value;
            if (value) {
                p.IsRead = value;
            }
        }
        else if (type === "delete") {
            f.IsDelete = value;
        }
        else if (type === "save") {
            f.IsSave = value;
        }
        else if (type === "update") {

            if (value) {
                p.IsUpdate = value;
            }
            f.IsUpdate = value;
        }
    }
    const permissionRowClick = (pageID) => {
        if (fieldList && fieldList.PageID === pageID) {
            setFieldList({});
            return;
        }
        setFieldList("PENDING");
        const onSuccess = (res) => {
            setFieldList({ PageID: pageID, List: res });
        }
        getPageFieldList(pageID, userID, onSuccess);


    }
    const checkAll = (type, value) => {
        if (!panelItems || panelItems === "PENDING") {
            return;
        }
        panelItems.forEach(p => {
            let pr = changedItems.current.find(c => c.ID === p.ID);
            if (!pr) {
                pr = {};
                pr.ID = p.ID;
                pr.UserID = userID;
                changedItems.current.push(pr);
            }

            if (type === "read") {
                pr.IsRead = p.IsRead = value;
            }
            else if (type === "delete") {
                pr.IsDelete = p.IsDelete = value;
            }
            else if (type === "save") {
                pr.IsSave = p.IsSave = value;
            }
            else if (type === "update") {
                pr.IsUpdate = p.IsUpdate = value;
            }
            setPanelItems([...panelItems]);
        });
    }
    return (
        <div style={{ border: "1px solid #b1abab", borderRadius: "3px", padding: "8px", margin: "0 0 5px 0" }}>
            {subMenuDisplay === "0" && <CaretLeftFill />}{subMenuDisplay === "500px" && <CaretDownFill />}<span className='treeviewItem' onClick={menuClick}>{title}</span>
            <div className='row'>
                <div className='treeviewSubItem col-md-3' style={{ maxHeight: subMenuDisplay, paddingLeft: 0 }}>
                    {items && items.map((item, i) => {
                        return (
                            <Fragment key={i}>
                                {item.type === "a" &&
                                    <a href={item.href} onClick={item.onClick} className="treeNode">
                                        {item.icon}
                                        <span style={{ color: "black", fontSize: "13px", marginRight: "8px" }}>{item.text}</span>
                                    </a>
                                }
                                {item.type === "link" &&
                                    <Link to={{ pathname: item.to, state: null }} onClick={e => { item.onClick(e); nodeClick(item.name, item.text, item.icon, false); }} className="treeNode">
                                        {item.icon}
                                        <span style={{ color: "black", fontSize: "13px", marginRight: "8px" }}>{item.text}</span>
                                    </Link>
                                }
                                {
                                    !item.type &&
                                    <div onClick={item.onClick} className="treeNode">
                                        {item.icon}
                                        <span style={{ color: "black", fontSize: "13px", marginRight: "8px" }}>{item.text}</span>
                                    </div>
                                }
                                {
                                    subItems && subItems.Nodes && subItems.Name === item.name &&
                                    subItems.Nodes.map((child, ch) =>
                                        <Fragment key={ch}>
                                            <div onClick={(e) => { nodeL2Click(e.currentTarget); nodeClick(child.Name, child.text, <GridFill />, true, child.Others) }} className="treeNodeL2">
                                                <GridFill />
                                                <span style={{ color: "black", fontSize: "11px", marginRight: "5px" }}>{child.text}</span>
                                            </div>
                                        </Fragment>
                                    )
                                }
                            </Fragment>)
                    })}
                </div>
                {hasPanel &&
                    <div className="col-md-9" style={{ paddingRight: 0 }}>
                        <Card>
                            <Card.Header style={{ backgroundColor: "#db6784", color: "black" }}>{currentNode.Icon}&nbsp;{currentNode.Title && 'دسترسی های مربوط به ' + currentNode.Title}</Card.Header>
                            <Card.Body style={{ minHeight: "200px", maxHeight: "350px", overflowY: "auto", backgroundColor: "rgb(247 237 242)", padding: 0 }} className='scThin'>
                                <Table style={{position:"relative", "--rowColor":"#c9cfe6"}} className='designedTable mb-0'>
                                    <thead>
                                        <tr>
                                            <th style={{position:"sticky", top:0, backgroundColor:"#9daae2", zIndex:50}}>نام صفحه</th>
                                            <th style={{position:"sticky", top:0, backgroundColor:"#9daae2", zIndex:50}}><input type='checkbox' className='form-check-input' onChange={e => checkAll("read", e.target.checked)} />
                                                &nbsp;<label style={{ marginTop: "2px" }}>خواندن</label>
                                            </th>
                                            <th style={{position:"sticky", top:0, backgroundColor:"#9daae2", zIndex:50}}><input type='checkbox' className='form-check-input' onChange={e => checkAll("update", e.target.checked)} />
                                                &nbsp;<label style={{ marginTop: "2px" }}>بروزرسانی</label>
                                            </th>
                                            <th style={{position:"sticky", top:0, backgroundColor:"#9daae2", zIndex:50}}><input type='checkbox' className='form-check-input' onChange={e => checkAll("save", e.target.checked)} />
                                                &nbsp;<label style={{ marginTop: "2px" }}>ایجاد</label>
                                            </th>
                                            <th style={{position:"sticky", top:0, backgroundColor:"#9daae2", zIndex:50}}><input type='checkbox' className='form-check-input' onChange={e => checkAll("delete", e.target.checked)} />
                                                &nbsp;<label style={{ marginTop: "2px" }}>حذف</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            panelItems === "PENDING" &&
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center" }}><Loader type="BallTriangle" width={30} height={30} color="#bb1370" /></td>
                                            </tr>
                                        }
                                        {
                                            panelItems.Message &&
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center",color:"red" }}>{panelItems.Message}</td>
                                            </tr>
                                        }                                        
                                        {panelItems && Array.isArray(panelItems) && panelItems.map((item, i) =>
                                            <Fragment key={i}>
                                                <tr style={{ cursor: "pointer" }}>
                                                    <td onClick={() => permissionRowClick(item.ID)}>{item.HasField &&<span><CardChecklist size={14} color='blue'/>&nbsp;</span>}{item.PersianName}</td>
                                                    <td><input type='checkbox' className='form-check-input' checked={item.IsRead ?? false} onChange={e => permissionClick("read", e.target.checked, item.ID)}/></td>
                                                    <td><input type='checkbox' className='form-check-input' checked={item.IsUpdate ?? false} onChange={e => permissionClick("update", e.target.checked, item.ID)}
                                                     disabled={item.IsReport} style={{background: item.IsReport ?"#2250ff":"not-set"}}/></td>
                                                    <td><input type='checkbox' className='form-check-input' checked={item.IsSave ?? false} onChange={e => permissionClick("save", e.target.checked, item.ID)} 
                                                    disabled={item.IsReport} style={{background: item.IsReport ?"#2250ff":"not-set"}}/></td>
                                                    <td><input type='checkbox' className='form-check-input' checked={item.IsDelete ?? false} onChange={e => permissionClick("delete", e.target.checked, item.ID)} 
                                                    disabled={item.IsReport} style={{background: item.IsReport ?"#2250ff":"not-set"}}/></td>
                                                </tr>
                                                {fieldList && fieldList.List && fieldList.List.length > 0 && fieldList.PageID === item.ID &&
                                                    <tr >
                                                        <td colSpan={5} style={{ padding: "5px" }}>
                                                            <div style={{ width: "50%", border: "1px solid gray", padding: "5px", borderRadius: "2px", maxHeight: "533px" }}>
                                                                <table style={{ width: "100%" }}>
                                                                    <thead style={{ backgroundColor: "#d0a9dd" }}>
                                                                        <tr>
                                                                            <th style={{ padding: "5px" }}>نام فیلد</th>
                                                                            <th style={{ padding: "5px" }}>خواندن</th>
                                                                            <th style={{ padding: "5px" }}>بروزرسانی</th>
                                                                            <th style={{ padding: "5px" }}>ایجاد</th>
                                                                            <th style={{ padding: "5px" }}>حذف</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {fieldList.List.map((field, f) =>
                                                                            <tr key={f} style={{ backgroundColor: "#e5dfdf" }}>
                                                                                <td style={{ padding: "4px" }}>{field.Name}</td>
                                                                                <td style={{ padding: "4px" }}><input type='checkbox' className='form-check-input' defaultChecked={field.IsRead ?? false}
                                                                                    onChange={e => fieldPermissionClick("read", e.target.checked, item.ID, field.ID)} /></td>
                                                                                <td style={{ padding: "4px" }}><input type='checkbox' className='form-check-input' defaultChecked={field.IsUpdate ?? false}
                                                                                    onChange={e => fieldPermissionClick("update", e.target.checked, item.ID, field.ID)} /></td>
                                                                                <td style={{ padding: "4px" }}><input type='checkbox' className='form-check-input' defaultChecked={field.IsSave ?? false}
                                                                                    onChange={e => fieldPermissionClick("save", e.target.checked, item.ID, field.ID)} /></td>
                                                                                <td style={{ padding: "4px" }}><input type='checkbox' className='form-check-input' defaultChecked={field.IsDelete ?? false}
                                                                                    onChange={e => fieldPermissionClick("delete", e.target.checked, item.ID, field.ID)} /></td>
                                                                            </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>}
                                            </Fragment>
                                        )
                                        }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </div>}
            </div>
        </div>)
}
export default TreeViewItem;